import { render, staticRenderFns } from "./OrderItemCommitmentList.vue?vue&type=template&id=aab6a15a&"
import script from "./OrderItemCommitmentList.vue?vue&type=script&lang=js&"
export * from "./OrderItemCommitmentList.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemCommitmentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports